"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _utils = require("../utils/utils");

var assignValue = function assignValue(_ref) {
  var name = _ref.name,
      index = _ref.index,
      breakpoints = _ref.breakpoints,
      source = _ref.source,
      result = _ref.result;

  for (var i = index; i >= 0; i--) {
    var currentValue = (0, _lodash.get)(source, [name, breakpoints[i]]);

    if (typeof currentValue === 'number') {
      (0, _lodash.set)(result, [name, breakpoints[index]], currentValue);
      break;
    }
  }
};

var shouldReassign = function shouldReassign(_ref2) {
  var theme = _ref2.theme,
      breakpoints = _ref2.breakpoints,
      position = _ref2.position;
  return Object.keys(theme).some(function (name) {
    var currentValue = (0, _lodash.get)(theme, [name, breakpoints[position]]);
    var previousValue = (0, _lodash.get)(theme, [name, breakpoints[position - 1]]);
    return currentValue !== previousValue;
  });
};

var optimizeTheme = function optimizeTheme(_ref3) {
  var theme = _ref3.theme,
      breakpoints = _ref3.breakpoints;
  var result = {};
  breakpoints.forEach(function (bp, i) {
    if (shouldReassign({
      theme: theme,
      breakpoints: breakpoints,
      position: i
    })) {
      Object.keys(theme).forEach(function (name) {
        assignValue({
          name: name,
          index: i,
          breakpoints: breakpoints,
          source: theme,
          result: result
        });
      });
    }
  });
  return result;
};

var normalizeTheme = function normalizeTheme(_ref4) {
  var props = _ref4.props,
      keywords = _ref4.keywords,
      breakpoints = _ref4.breakpoints;
  var theme = (0, _utils.calculateTheme)({
    props: props,
    keywords: keywords,
    breakpoints: breakpoints
  });
  var result = {}; // normalize size, paddings, ... for each breakpoint

  breakpoints.forEach(function (bp, i) {
    Object.keys(theme).forEach(function (name) {
      assignValue({
        name: name,
        index: i,
        breakpoints: breakpoints,
        source: theme,
        result: result
      });
    });
  });
  return result;
};

var _default = function _default(_ref5) {
  var props = _ref5.props,
      keywords = _ref5.keywords,
      breakpoints = _ref5.breakpoints;
  var helper = normalizeTheme({
    props: props,
    keywords: keywords,
    breakpoints: breakpoints
  });
  return optimizeTheme({
    theme: helper,
    breakpoints: breakpoints
  });
};

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/Col/utils.js
// module id = 240
// module chunks = 0